// @flow

import { RESORT_GRID } from 'Client/cms/toolkit/constants';
import { ProductsGridLine } from 'Components/lines/products-grid-line/ProductsGridLine';
import { productsGridResolver } from './productsGrid.resolver';

export const productsGridDescriptor = {
  name: RESORT_GRID,
  component: ProductsGridLine,
  resolve: productsGridResolver.resolve,
};
